import { pluginApiUrlMap } from './url';

export const page_size = 24;

export const searchResourceByLabel = (label = '', page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$get('community/api/label/resources', {
    params: {
      page_size,
      sort_type,
      label,
      page_num,
    },
  });

export const searchPluginByLabel = (plugin_cata = '', page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$get('/community/api/plugin/label/plugins', {
    params: {
      page_size,
      sort_type,
      plugin_cata,
      page_num,
    },
  });

export const searchResourceByKeyword = (keywords = '', page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$post('/community/api/search', {
    page_size,
    sort_type,
    keywords,
    res_cata: '全部',
    page_num,
  });

export const searchPluginByKeyword = (keywords = '', page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$post('/community/api/plugin/search', {
    page_size,
    sort_type,
    keywords,
    page_num,
  });

export const searchResourceByCata = (res_cata = '', page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$get('/community/api/by-catalog', {
    params: {
      page_size,
      sort_type,
      res_cata,
      page_num,
    },
  });

export const searchPluginByCata = (page_num = 1, sort_type = 0, axios = window.$nuxt.$axios) =>
  axios.$get(pluginApiUrlMap.getPlugins, {
    params: {
      page_size,
      sort_type,
      page_num,
    },
  });
